import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_CONSULTS_REQUEST } from "./constants";
import { Action, ConsultsState } from "./types";

function items(state: ConsultsState = {}, action: Action): ConsultsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONSULTS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_CONSULTS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_CONSULTS_REQUEST):
    case getFailureActionType(FETCH_CONSULTS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const consults = combineReducers({ items, isFetching });
